import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_NLPData } from '@app/hcs-shared';
export const dispatch_onNLPDatasUpdated = new ThunderDispatcherV3('__onNLPDatasUpdated');
export class ModuleFE_NLPData_Class extends ModuleFE_BaseApi {
    constructor() {
        super(DBDef_NLPData, dispatch_onNLPDatasUpdated);
    }
}
export const ModuleFE_NLPData = new ModuleFE_NLPData_Class();
//# sourceMappingURL=ModuleFE_NLPData.js.map